/* eslint-disable no-unused-vars */
// noinspection JSUnusedGlobalSymbols
export enum ValueType {
  Baseline,
  Target,
  Contribution,
}
